// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import { store } from './store';
import LoadScript from 'vue-plugin-load-script';
import mixin from '@/mixins/handler.js';

Vue.config.productionTip = false;
Vue.use(LoadScript);
Vue.mixin(mixin);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
});


// WEBPACK FOOTER //
// ./source/main.js